export const courseData = {
  "workforce": {
    "training": [
      {
        "name": "Employer Initiative Training",
        "description": "We create innovative and engaging training solutions tailored to your business needs and aligned with your companys objectives. MDX adheres to company guidelines to ensure the highest quality training experience, offering everything from basic safety training to advanced technical programs and including specialized training for employers.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "Power & Utilities Training",
        "description": "MDX utility Line identification and program prepares you to work in the power utility line industry as apprentice linemen. The curriculum is designed to provide a complete understanding of electromagnetic utility locating and a deeper level of underground infrastructure protection.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "NCCER Electrician Level 1 Training",
        "description": "PEC Basic Orientation provides general safety information that workers need to know before entering a company facility and while performing their assigned work duties. Students will learn about hazards they may encounter in their workplace and become familiar with various practices to mitigate those hazards. Students will also gain understanding of their rights under OSHA and how those rights apply to their workplace.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "Level 1 Surveying Training & Certifications",
        "description": "In depth, hands-on practice of different surveys including, but not limited to boundary, topography, construction, engineering, leveling, and as-built surveys. This course will also provide basic first aid skills and safety requirements.", 
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "Qualified Operator Qualification (OQ) - Pipeline Training Cover Task & Assessments",
        "description": "MDX delivers a comprehensive client’s OQ program. Including OQ Field Evaluations, building and maintaining OQ specific pipeline operator covered tasks, perform OQ field audits to ensure compliance, diversification reports and client representation.",
        "details": [
          { "topic": "Covers pipeline tasks aligned with Operator Qualification standards." },
          { "topic": "Emphasis on regulatory compliance and safe operating practices." },
          { "topic": "Assessments conducted to verify operator competence." },
          { "topic": "Certification process ensuring operators meet industry OQ requirements." }
        ]
      },
      {
        "name": "Level 2 Surveying Training & Certifications",
        "description": "In depth, hands-on practice of different surveys including, but not limited to boundary, topography, construction, engineering, leveling, and as-built surveys. This course will also provide basic first aid skills and safety requirements.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "NCCER Carpentry Level 1 Training",
        "description": "MDX offers detailed training that covers NCCER's Carpentry Level 1 program which helps learners build general carpentry skills before moving into advanced topical coverage of framing and finish carpentry, as well as concrete and form carpentry.",
        "details": [
          { "topic": "Introduces foundational carpentry skills for entry-level learners." },
          { "topic": "Covers basic hand tools, power tools, and construction materials." },
          { "topic": "Provides instruction in framing, formwork, and beginning finish carpentry." },
          { "topic": "Prepares participants for advanced carpentry training and on-the-job success." }
        ]
      },
      {
        "name": "Power & Utilities Training",
        "description": "MDX utility Line identification and program prepares you to work in the power utility line industry as apprentice linemen. The curriculum is designed to provide a complete understanding of electromagnetic utility locating and a deeper level of underground infrastructure protection.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "Construction Readiness Program",
        "description": "MDX offers construction readiness training that covers NCCER's Construction Workforce Development program which is designed to meet the growing need for skilled professionals in the construction industry.",
        "details": [
          { "topic": "Introduces essential skills and knowledge for entry into construction." },
          { "topic": "Builds a strong foundation in construction basics and safe work habits." },
          { "topic": "Focus on safety, tool use, and workplace best practices." },
          { "topic": "Prepares participants for advanced craft training and jobsite success." }
        ]
      }
    ],
    "services": [
      {
        "name": "Business Curriculum & Employee Program Development",
        "description": "MDX can train employers and help organizations develop their internal curriculum to properly assess procedures and protocols. We can also provide guidance on how to enhance your team's capabilities.",
        "details": [
          { "topic": "Training designed to strengthen employer leadership and workforce skills." },
          { "topic": "Support in developing internal curriculum tailored to company needs." },
          { "topic": "Guidance on assessing workplace procedures and protocols for compliance." },
          { "topic": "Builds sustainable programs that improve safety, efficiency, and culture." }
        ]
      },
      {
        "name": "Educational Consulting (ATF) & ICPT Course",
        "description": "A secondary or postsecondary school (high school, college, university) working in partnership with MDX Workforce Consulting Center and Training Academy that has successfully completed an approval process for recognition of its training program can become an ATF.",
        "details": [
          { "topic": "Guidance on meeting NCCER accreditation requirements." },
          { "topic": "Training for instructors through the Instructor Certification Training Program." },
          { "topic": "Support in setting up curriculum, testing, and record-keeping systems." },
          { "topic": "Pathway for schools to become recognized NCCER Training Units." }
        ]
      },
      {
        "name": "Career & Trade Assessments",
        "description": "MDX offers a complete series of entry- and journey-level written assessments as part of its National Craft Assessment and Certification Program (NCACP). These assessments evaluate the knowledge of an individual in a specific craft area and provide a prescription for upgrade training when needed.",
        "details": [
          { "topic": "Written entry- and journey-level assessments." },
          { "topic": "Evaluates knowledge and skills." },
          { "topic": "Provides clear benchmark for employee proficiency and career progression." },
          { "topic": "Generates prescriptions for upgrade training to close skill gaps." }
        ]
      },      
      {
        "name": "Pipeline Inspectors",
        "description": "MDX offers experienced field pipeline inspectors. We work around the clock for our clients' needs, from supervision to carrying an entire crew to complete extensive projects in new or current pipeline construction.",
        "details": [
          { "topic": "Experienced inspectors available for all phases of pipeline projects." },
          { "topic": "Support ranging from site supervision to full crew management." },
          { "topic": "Services cover new construction to existing pipeline operations." },
          { "topic": "24/7 availability to meet client schedules and project demands." }
        ]
      },     
      {
        "name": "Curriculum Development for Employers",
        "description": "MDX Workforce Academy provides employer-focused workforce services and training solutions designed to align with real industry needs. Our curriculum helps employers build stronger teams by offering upskilling programs, technical training, compliance support, and leadership development. We partner directly with businesses in construction, oil and gas, hospitality, and general industry to create customized training pathways that enhance and improve productivity and ensure workforce readiness.",
        "details": [
          { "topic": "Customized training pathways built around real industry needs." },
          { "topic": "Upskilling, technical training, compliance support, " },
          { "topic": "Partnerships with employers across construction, oil & gas, hospitality and general industry." },
          { "topic": "Programs designed to boost workforce readiness and productivity." }
        ]
      },         
    ]    
  },  
  "safety": {
    "training": [
      {
        "name": "Scissor Lift Training",
        "description": "MDX’s Scissor-lift course satisfies OSHA’s requirements for the classroom portion of operator safety training.",
        "details": [
          {
            "topic": "Safe operation and stability awareness for elevated work."
          },
          {
            "topic": "Pre-use inspections and hazard recognition."
          },
          {
            "topic": "Proper fall protection and platform safety practices."
          },
          {
            "topic": "Compliance with OSHA and industry standards."
          }
        ]
      },
      {
        "name": "Aerial Lift Training",
        "description": "MDX provides Aerial Lift (Man-lift & Scissor lift) Certification. Our program teaches essential knowledge on how to properly operate and abate hazards within the workplace. Our trainee certification program will provide the knowledge, skills and tools on how to properly use the equipment depending on classification.",
        "details": [
          {
            "topic": "Safe operation of boom and articulating lifts in various environments."
          },          
		  {
            "topic": "Pre-use inspections and equipment setup requirements."
          },       
		  {
            "topic": "Load limits, stability, and emergency procedures."
          },       
		  {
            "topic": "Compliance with OSHA operator standards."
          }
		  
        ]
      },
      {
        "name": "OSHA Competent Person Fall Protection Training",
        "description": "This course focuses on the best practices in regards to fall protection, fall protection equipment, and fall protection safety. Participants are introduced to possible fall related hazards as well as the components of a fall protection system including body support, anchorages, connectors and rescue. Upon successful completion of this course, the student will receive a certificate acknowledging they have met or exceeded requirements as an Authorized Person.",
        "details": [
          {
            "topic": "Defines the role and responsibilities of a Competent Person under OSHA standards."
          },          
		  {
            "topic": "Identifies fall hazards and implements corrective actions."
          },          
		  {
            "topic": "Covers inspection of fall protection systems and equipment."
          },          
		  {
            "topic": "Ensures compliance with OSHA regulations for workplace safety."
          }
        ]
      },
      {
        "name": "Traffic Control Supervisor Training",
        "description": "This course is designed to train those who will be actively involved in designing or setting up and maintaining temporary traffic control in a work zone. It moves from the concepts and techniques to the implementation of traffic control plans and techniques for installation and removal. Workshops included in the course are designed to provide hand-on, real world examples in designing temporary traffic control setups and also recognizing, analyzing and correcting deficiencies. An additional, vital objective of this course is teaching students the skills necessary to become an effective supervisor, capable of leading a team in the field.",
        "details": [
          { "topic": "Prepares supervisors to plan, implement, and oversee traffic control operations." },
          { "topic": "Emphasizes work zone safety and protecting both workers and the public." },
          { "topic": "Covers traffic control devices, signage, and proper placement methods." },
          { "topic": "Ensures compliance with state and federal roadway safety requirements." }
        ]
      },
      {
        "name": "PEC Basic Orientation",
        "description": "PEC Basic Orientation provides general safety information that workers need to know before entering a company facility and while performing their assigned work duties. Students will learn about hazards they may encounter in their workplace and become familiar with various practices to mitigate those hazards. Students will also gain understanding of their rights under OSHA and how those rights apply to their workplace.",
        "details": [
          { "topic": "Introductory safety training for oil and gas industry workers." },
          { "topic": "Covers key topics: HazCom, fire protection, confined space, and more." },
          { "topic": "Promotes safe work habits and hazard awareness on jobsites." },
          { "topic": "Meets industry requirements for basic safety orientation." }
        ]
      },
      {
        "name": "OSHA Competent Person For Excavation, Shoring, and Trenching Training",
        "description": "This excavation training covers the OSHA Excavation Standard and safety and health aspects of excavation and trenching. Course topics include practical soil mechanics and its relationship to the stability of shored and unshored slopes and walls of excavations, introduction of various types of shoring (wood timbers and hydraulic), soil classification, and use of protective systems.", 
        "details": [
          { "topic": "Defines duties of a Competent Person in excavation and trenching operations." },
          { "topic": "Identifies soil types, hazards, and protective system requirements." },
          { "topic": "Covers inspection of trenches, shoring, shielding, and access/egress." },
          { "topic": "Ensures compliance with OSHA standards to prevent cave-ins and related risks." }
        ]
      },
      {
        "name": "Flagger - DOT Assessment",
        "description": "The topics discussed in this course involve a thorough understanding of flagging procedures, proper use of required equipment, review of flagging skills from hands-on training and classroom activities, and coordinate traffic movement through the work zone. Students will receive a full color, waterproof picture ID card, each with its own individual assigned number to prove its authenticity.",
        "details": [
          { "topic": "Prepares workers to safely control traffic in roadway work zones." },
          { "topic": "Covers proper use of hand signals, signs, and communication devices." },
          { "topic": "Emphasizes visibility, positioning, and worker/public safety." },
          { "topic": "Builds confidence to handle real-world traffic situations effectively." }
        ]
      },
      {
        "name": "OSHA Confined Space Competent Person Training",
        "description": "This course will demonstrate how to work in a confined space environment to maximize safety for you and those around you, as well as certify you under the OSHA Confined Space standard. The objective of this training is to protect those entering or working around a confined space. MDX will teach the physical, chemical, and biological principles related to safe working with confined spaces.",
        "details": [
          { "topic": "Defines the role and responsibilities of a Competent Person in confined spaces." },
          { "topic": "Identifies confined space hazards and required protectice measures." },
          { "topic": "Covers entry permits, monitoring, and rescue procedures." },
          { "topic": "Ensures compliance with OSHA confined space standards." }
        ]
      },
      {
        "name": "H2S Clear Safety Training",
        "description": "H2S Clear was designed to improve employee safety for general industry workers who may potentially come in contact with hydrogen sulfide in the workplace. This program meets the revised standards set forth in the ANSI/ASSE Z390.1. MDX will provide students with crucial knowledge of the dangers of H2S and the precautions, tools and controls necessary when working in potential H2S environments. Our Hands-On training will also include techniques on inspection, maintenance, and proper operation of how to use a self-contained breathing apparatus (S.C.B.A.).",
        "details": [
          { "topic": "Provides awareness of hydrogen sulfide (H2S) hazards in oil and gas operations." },
          { "topic": "Covers detection methods, monitoring equipment, and alarm responses." },
          { "topic": "Teaches proper use of respiratory protection and emergency procedures." },
          { "topic": "Ensures workers can recognize, react to, and escape H2S exposure safely." }
        ]
      },
      {
        "name": "Rigging Training",
        "description": "Crane Safety and Emergency Procedures. Covers safety standards and best safety practices relevant to the operation of cranes. Describes safety considerations related to power lines, weather conditions, and specific crane functions. Basic Principles of Cranes Introduces mobile crane equipment with an in-depth discussion of terminology and nomenclature.",
        "details": [
          { "topic": "Covers safe rigging practices for lifting and moving loads." },
          { "topic": "Identifies rigging gear, hardware, and inspection requirements." },
          { "topic": "Emphasizes load calculations, weight limits, and balance control." },
          { "topic": "Builds skills to ensure safe, efficient, and accident-free lifting operations." }
        ]
      },
      {
        "name": "OSHA Scaffold Competent Person Training",
        "description": "MDX scaffold Competent Person training provide full concepts and procedures involved with scaffold building. This includes handling various conditions in a responsible manner, developing a safety plan, and inspecting scaffold equipment on a regular basis. A scaffold builder masters all concepts and procedures involved with scaffold building. He/she interprets safety and hazard warnings to ensure the proper handling of scaffolding.",
        "details": [
          { "topic": "Defines the role and responsibilities of a Competent Person on scaffolds." },
          { "topic": "Covers scaffold design, assembly, inspection, and safe use." },
          { "topic": "Identifies common hazards such as falls, instability, and overloading." },
          { "topic": "Trains supervisors to maintain safe scaffolding operations on worksites." }
        ]
      },
      {
        "name": "ASHI Certification/CPR & First-Aid Training",
        "description": "ASHI Basic First Aid was created to help students develop basic first aid knowledge, skills and the confidence to respond. The program is an excellent choice for both the community and workplace setting and conforms to the 2015 AHA and ARC Guidelines Update for Medic First Aid.",
        "details": [
          { "topic": "Teaches lifesaving skills for responding to medical emergencies." },
          { "topic": "Covers CPR techniques for adults, children, and infants." },
          { "topic": "Instruction on using Automated External Defibrillators (AEDs)." },
          { "topic": "Builds confidence to act quickly in workplace and everyday emergencies." }
        ]
      },
      {
        "name": "NFPA 70E Arc Flash Training",
        "description": "Describes how to assess and eliminate shock, arc blast, and arc flash hazards using the practical safe working requirements detailed in NFPA 70E®, Standard for Electrical Safety in the Workplace. Where it is not possible to eliminate a hazard, an energized electrical work permit must be completed, and workers must be protected by appropriate safety procedures and personal protective equipment.",
        "details": [
          { "topic": "Covers electrical safety standards to protect against arc flash and shock hazards." },
          { "topic": "Explains proper use of PPE, tools, and insulated equipment." },
          { "topic": "Emphasizes safe work practices, approach boundaries," },
          { "topic": "Ensures compliance with NFPA 70E and OSHA electrical safety requirements." }
        ]
      },
      {
        "name": "Line Locator Training",
        "description": "We currently offer our standard line locating training program in two lengths, or we are happy to customize a program to your needs. All classes include practical hands-on training with line locator equipment, lead to wallet cards, and industry recognized credentials.",
        "details": [
          { "topic": "Teaches methods for identifying and marking underground utilities." },
          { "topic": "Covers proper use of locating equipment and interpretation of signals." },
          { "topic": "Emphasizes safe digging practices to prevent line strikes and damage." },
          { "topic": "Builds awareness of utility maps, records, and one-call requirements." }
        ]
      },
      {
        "name": "TDLR-Approved Safe Driving Course",
        "description": "Protect your team and reduce liability with our TDLR-approved Driving Safety Course, designed specifically for companies committed to safety. This engaging, easy-to-implement program helps employees improve their driving habits, stay compliant with state requirements, and reduce risk on the road. Ideal for fleet drivers or any staff who drive as part of their job.",
        "details": [
          { "topic": "State-approved program designed to improve driver safety and awareness." },
          { "topic": "Covers defensive driving techniques and crash prevention strategies." },
          { "topic": "Reviews traffic laws, road signs, and driver responsibilities." },
          { "topic": "May qualify participants for ticket dismissal and insurance discounts." }
        ]
      },
      {
        "name": "IADC Rig Pass Training",
        "description": "Our IADC Rig Pass Program delivers a standardized safety orientation program for new and current employees and prepares your workforce for any operating environment, at any site, Onshore or Offshore. Our Rig Pass is endorsed by SafeLandUSA and SafeGulf. This is an orientation course designed specifically for our US Onshore E&P Industry and is recognized by many oil and gas companies. This program is endorsed by SafeGulf and SafeLandUSA.",
        "details": [
          { "topic": "Provides orientation for workers entering oil and gas drilling and service sites." },
          { "topic": "Covers key safety topics: hazard recognition, PPE, and safe work practices." },
          { "topic": "Emphasizes stop work authority and responsibility for safe operations." },
          { "topic": "Meets industry standards for basic rig site safety orientation." }
        ]
      },
      {
        "name": "Lockout-Tagout (LOTO) Training",
        "description": "Lockout-tagout (LOTO) is a safety procedure which is used in industry and research settings to ensure that dangerous machines are properly shut off and not able to be started up again prior to the completion of maintenance or servicing work. MDX Safety provides Lockout Tagout (LOTO) safety courses that are based on OHSA LOTO regulations. This training teaches proper lockout/tagout procedure, equipment, required lockout tagout devices, hazardous energy sources, injury prevention and legislative requirements.",
        "details": [
          { "topic": "Teaches procedures to control hazardous energy during servicing and maintenance." },
          { "topic": "Covers lockout devices, tags, and verification of zero energy state." },
          { "topic": "Defines roles of authorized and affected employees in LOTO activities." },
          { "topic": "Prevents accidental startup, protecting workers from serious injuries." }
        ]
      },
      {
        "name": "AHA Certification/CPR & First-Aid Training",
        "description": "This course is designed for community and workplace participants like teachers, coaches, camp counselors, school bus drivers, personal trainers, daycare workers, babysitters, construction workers, etc.",
        "details": [
          { "topic": "" },
          { "topic": "" },
          { "topic": "" },
          { "topic": "" }
        ]
      },
      {
        "name": "OSHA 10 & 30 Hours - Construction",
        "description": "Most workers in construction, building development, and other related fields will need to take hazard recognition training. This will ensure that workers are able to identify, predict, prevent, and stop potential hazards in the workplace.", 
        "details": [
          { "topic": "Provides foundational safety training for construction workers and supervisors." },
          { "topic": "OSHA 10 covers entry-level awareness; OSHA 30 covers advanced supervisory topics." },
          { "topic": "Topics include hazard recognition, PPE, fall protection, and health standards." },
          { "topic": "Promotes safer worksites and compliance with OSHA construction requirements." }
        ]
      },
      {
        "name": "OSHA 10 & 30 Hours - General Industry",
        "description": "MDX Inc’s OSHA Specialized Hands-On Training Safety Program is intended to provide a variety of trainings on how to identify, abate, and ultimately prevent job hazards on a job site. These courses cover a variety of general industry safety and health hazards which a worker may encounter on a job site. Our courses emphasize proper hazard identification, avoidance, and control in compliance with OSHA standards.",
        "details": [
          { "topic": "Provides safety training for employees and supervisors across general industry settings." },
          { "topic": "OSHA 10 covers entry-level workplace hazards; OSHA 30 expands into management and oversight." },
          { "topic": "Topics include machine guarding, hazard communication, ergonomics, and electrical safety." },
          { "topic": "Builds awareness to reduce risks and maintain compliacnce with OSHA standards." }
        ]
      },
      {
        "name": "Forklift Training",
        "description": "A forklift operator will identify different types of forklifts and their applications on construction sites. He/she will master procedures for lifting, transporting, and placing various types of loads. He/she will also know the duties and responsibilities of operators, as well as safety rules, and operator preventive maintenance duties.",
        "details": [
          { "topic": "Teaches safe operation of powered industrial trucks in the workplace." },
          { "topic": "Covers inspections, load handling, and stability awareness." },
          { "topic": "Emphasizes pedestrian safety and hazard recognition around forklifts." },
          { "topic": "Builds operator confidence to ensure efficient and accident-free operations." }
        ]
      },
      {
        "name": "Skid Steer Training",
        "description": "A skid steer operator masters all concepts and procedures involved in the operation of skid steers. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies the main attachments used with skid steers and uses the skid steer to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Covers safe operation of skid steer loaders in various work environments." },
          { "topic": "Emphasizes pre-use inspections, stability, and load management." },
          { "topic": "Identifies common hazards such as rollovers, pinch points, and blind spots." },
          { "topic": "Builds operator skills to perform tasks safely and productively." }
        ]
      },
      {
        "name": "Trackhoe Training",
        "description": "A trackhoe operator masters all concepts and procedures involved in the operation of trackhoes. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies attachments and uses the trackhoe to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Teaches safe operation of trackhoes on the jobsite." },
          { "topic": "Covers equipment inspections, controls, and safe digging practices." },
          { "topic": "Emphasizese hazard awareness around trenches, utilities, and swing radius." },
          { "topic": "Builds operator skills for efficient and safe earthmoving operations." }
        ]
      },
      {
        "name": "Backhoe Training",
        "description": "A backhoe operator masters all concepts and procedures involved in the operation of backhoes. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies attachments and uses the backhoe to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on proper and safe operation of backhoe loaders." },
          { "topic": "Reviews inspection steps, control functions, and digging procedures." },
          { "topic": "Highlights key hazards including utilities, trenches, and equipment movement." },
          { "topic": "Builds operator competency for safe and efficient jobsite performance." }
        ]
      },
      {
        "name": "Overhead Crane Training",
        "description": "Overhead crane and hoist training provide instruction on safe operating practices, proper load handling, pre-use inspection and accident avoidance. We place emphasis on informing the operator on the interaction of overhead crane components which makes an operator better able to provide early detection of unsafe conditions.",
        "details": [
          { "topic": "Teaches safe operation of overhead and gantry cranes in industrial settings." },
          { "topic": "Reviews pre-use inspections, rigging requirements, and load control techniques." },
          { "topic": "Emphasizes communication, hand signals, and coordination with rigging crews." },
          { "topic": "Builds operator competency to ensure safe and efficienct lifting operations." }
        ]
      },
      {
        "name": "Mini Excavator Training",
        "description": "A Mini Excavator operator masters all concepts and procedures involved in the operation of backhoes. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies attachments and uses the backhoe to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on proper and safe operation of compact excavators." },
          { "topic": "Reviews inspection steps, control functions, and digging procedures." },
          { "topic": "Highlights hazards such as utilities, trenches, and working in confined spaces." },
          { "topic": "Builds operator competency for safe and efficient excavation work." }
        ]
      },
      {
        "name": "Dozer Training",
        "description": "A dozer operator masters all concepts and procedures involved in the operation of dozers. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies attachments and uses the dozer to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on safe operation of bulldozers in construction and earthmoving." },
          { "topic": "Reviews pre-operation inspections, control functions, and ground-engagement techniques." },
          { "topic": "Identifies hazards such as rollovers, blind spots, and working on slopes." },
          { "topic": "Builds operator competency for efficient and safe grading and material moving." }
        ]
      },
      {
        "name": "Dump Truck Training",
        "description": "An off-road dump truck operator masters all concepts and procedures involved in the operation of off-road dump trucks. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she uses the off-road dump trucks to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on safe operation of on-road and off-road dump trucks." },
          { "topic": "Reviews inspections, load limits, dumping procedures, and control functions." },
          { "topic": "Emphasizes hazard awareness including tipping, blind spots, and traffic flow." },
          { "topic": "Builds operator skills for safe and efficient hauling and material handling." }
        ]
      },
      {
        "name": "Loaders Training",
        "description": "A loader operator masters all concepts and procedures involved in the operation of loaders. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies attachments and uses the loader to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on safe operation of front-end and wheel loaders." },
          { "topic": "Reviewe inspections, control functions, and propr loading techniques." },
          { "topic": "Identifies hazards including tipping, blind spots, and ground conditions." },
          { "topic": "Builds operator skills for efficient and safe material handling." }
        ]
      },
      {
        "name": "OSHA Competent Person for Excavation, Shoring and Trenching Training",
        "description": "This excavation training covers the OSHA Excavation Standard and safety and health aspects of excavation and trenching. Course topics include practical soil mechanics and its relationship to the stability of shored and unshored slopes and walls of excavations, introduction of various types of shoring (wood timbers and hydraulic), soil classification, and use of protective systems.",
        "details": [
          { "topic": "Defines the duties and authority of a Competent Person on excavation sites." },
          { "topic": "Reviews soil classification, protective systems, and hazard recognition." },
          { "topic": "Covers inspection of trenches, shoring, shielding, and safe access/egress." },
          { "topic": "Builds competency to maintain OSHA compliance and prevent cave-ins or related incidents." }
        ]
      },
      {
        "name": "Motor Grader Training",
        "description": "A motor grader operator masters all concepts and procedures involved in the operation of motor graders. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she identifies the main attachments used with motor graders and uses the motor grader to perform the appropriate work- related tasks.",
        "details": [
          { "topic": "Provides instruction on safe operation of motor graders for roadwork and site prep." },
          { "topic": "Reviews pre-operation inspections, controls, and grading techniques." },
          { "topic": "Identifies hazards such as rollovers, uneven terrain, and blind spots." },
          { "topic": "Build operator skills for accurate, safe, and efficient grading operations." }
        ]
      },
      {
        "name": "Rollers - Compaction Equipment Training",
        "description": "A compaction equipment operator masters all concepts and procedures involved in the operation of compaction equipment. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she uses the compaction equipment to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on safe operation and maneauvering of soil, gravel, and asphalt rollers." },
          { "topic": "Reviews inspections, controls, speed management, and compaction techniques." },
          { "topic": "Highlights hazards including rollovers, pinch points, and working on slopes or near crews." },
          { "topic": "Builds operator skills to achieve quality compaction while ensuring jobsite safety." }
        ]
      },
      {
        "name": "Scrapers, Trenches & Utility Tractors Training",
        "description": "A scraper operator masters all concepts and procedures involved in the operation of scrapers. This includes basic daily preventive maintenance, safety checking, and control of the machine. He/she uses the scraper to perform the appropriate work-related tasks.",
        "details": [
          { "topic": "Provides instruction on operating scrapers, trenchers, and tractors in construction and utility work." },
          { "topic": "Reviews inspections, control functions, digging/hauling methods, and safe operating practices." },
          { "topic": "Highlights hazards such as rollovers, underground utilities, moving parts, and bystander exposure." },
          { "topic": "Develops operator skills for efficient earthmoving, trenching, and utility support while maintaining safety." }
        ]
      },

    ],
    "services": [
    ]   
  },
  "txdot & environmental": {
    "training": [
      {
        "name": "Flagger - DOT Inspection Assessment",
        "description": "The topics discussed in this course involve a thorough understanding of flagging procedures, proper use of required equipment, review of flagging skills from hands-on training and classroom activities, and coordinate traffic movement through the work zone. Students will receive a full color, waterproof picture ID card, each with its own individual assigned number to prove its authenticity.",
        "details": [
          { "topic": "Evaluates flagger knowledge and skills through DOT-based assessments." },
          { "topic": "Reviews correct signaling, communication, and traffic control procedures." },
          { "topic": "Confirms understanding of visiblity, positioning, and work zone safety." },
          { "topic": "Ensures workers are qualified to manage traffic flow under real inspection standards." }
        ]
      },
      {
        "name": "Environmental Training - Storm Water",
        "description": "Stormwater Pollution Prevention Plans (SWPPPs) Training, and Stormwater Management Plans (SWMPs) Trainings. We provide in depth training on site-specific, written documents that keep your jobsite up to standards.",
        "details": [
          { "topic": "Introduces regulations and best practices for storm water management." },
          { "topic": "Covers erosion control, silt fence use, and spill prevention methods." },
          { "topic": "Highlights inspection, monitoring, and reporting responsibilities." },
          { "topic": "Promotes compliance while protecting waterways and the environment." }
        ]
      },
      {
        "name": "Traffic Control Supervisor Training",
        "description": "This course is designed to train those who will be actively involved in designing or setting up and maintaining temporary traffic control in a work zone. It moves from the concepts and techniques to the implementation of traffic control plans and techniques for installation and removal. Workshops included in the course are designed to provide hand-on, real world examples in designing temporary traffic control setups and also recognizing, analyzing and correcting deficiencies. An additional, vital objective of this course is teaching students the skills necessary to become an effective supervisor, capable of leading a team in the field.",
        "details": [
          { "topic": "Prepares supervisors to design, implement, and oversee traffic control operations." },
          { "topic": "Emphasizes protecting workers, motorists, and pedestrians in work zones." },
          { "topic": "Reviews proper setup of signs, barriers, and traffic control devices." },
          { "topic": "Builds leadership skills to maintain safe, compliant, and efficient work zones." }
        ]
      },
    ],
    "services": [
      {
        "name": "Flagger - DOT Inspection Assessment",
        "description": "The topics discussed in this course involve a thorough understanding of flagging procedures, proper use of required equipment, review of flagging skills from hands-on training and classroom activities, and coordinate traffic movement through the work zone. Students will receive a full color, waterproof picture ID card, each with its own individual assigned number to prove its authenticity.",
        "details": [
          { "topic": "Evaluates flagger knowledge and skills through DOT-based assessments." },
          { "topic": "Reviews correct signaling, communication, and traffic control procedures." },
          { "topic": "Confirms understanding of visibility, positioning, and work zone safety." },
          { "topic": "Ensures workers are qualified to manage traffic flow under real inspection standards." }
        ]
      },
      {
        "name": "Environmental Consulting - Storm Water",
        "description": "Stormwater Pollution Prevention Plans (SWPPPs) Training, and Stormwater Management Plans (SWMPs) Trainings. We provide in depth training on site-specific, written documents that keep your jobsite up to standards.",
        "details": [
          { "topic": "Provides expert guidance on storm water compliance and permitting." },
          { "topic": "Supports development of site-specific Storm Water Pollution Prevention Plans (SWPPP)." },
          { "topic": "Assists with inspections, monitoring, and regulatory reporting." },
          { "topic": "Helps organizations reduce environmental risk and protect waterways." }
        ]
      },      
      {
        "name": " Traffic Control Supervisor Assessment",
        "description": "This course is designed to train those who will be actively involved in designing or setting up and maintaining temporary traffic control in a work zone. It moves from the concepts and techniques to the implementation of traffic control plans and techniques for installation and removal.",
        "details": [
          { "topic": "Evaluates knowledge of traffic control standards and safe work zone practices." },
          { "topic": "Reviews ability to design, implement, and manage traffic control plans." },
          { "topic": "Confirms proper use of signs, barriers, and communication methods." },
          { "topic": "Verifies sueprvisor readiness to oversee compliant and efficient traffic operations." }
        ]
      },         
    ]   
  },
  "CEU": {
    "training": [
    ],
    "services": [
      {
        "name": "C.E.U. - Training by Industry",
        "description": "MDX can design fully customized trainings tailored to your organization’s needs, with the added integration of Continuing Education Units (C.E.U.s) to ensure professional recognition and advancement.",
        "details": [
          { "topic": "Customized training programs designed around speficic industry needs." },
          { "topic": "Integration of Coninueing Education Units (C.E.U.s) for professional growth." },
          { "topic": "Supports compliance, skill development, and workforce advancement." },
          { "topic": "Enhances employee credentials while adding organizational value." }
        ]
      }
    ]   
  }
};